import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => {
  return {
    path: "overview",
    component: withAsyncRouteLoading(
      () =>
        import(/* webpackChunkName: "overview" */ "./components").then(
          module => module.default
        )

      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [],
  };
};
